export type UrlFilterObject = {
  filterOn: string;
  filterValue: string;
};

export type UrlState = {
  q?: string;
  defaultFilter?: string;
  filter?: Array<UrlFilterObject>;
  type?: Array<string>;
  category?: string;
  size?: number;
  page?: number;
  sort?: string;
  colour?: number;
  searchTerm?: string;
  storeId?: number;
};

export type UrlFilters = {
  defaultFilter?: string;
  filter?: Array<UrlFilterObject>;
};
